import React from 'react';

// Scorinova logo — layered forward-pointing arrow icon

export function LogoIcon({ className = 'w-7 h-7' }) {
  return (
    <img
      src="/logo-icon.png"
      alt="Scorinova"
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}

export function LogoText({ size = 'text-xl' }) {
  return (
    <span
      className={`${size} text-white tracking-tight`}
      style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}
    >
      Scorinova
    </span>
  );
}

export function LogoFull({ iconSize = 'w-7 h-7', textSize = 'text-xl', subtitle = false }) {
  return (
    <div className="flex items-center gap-2.5">
      <LogoIcon className={iconSize} />
      <div>
        <LogoText size={textSize} />
        {subtitle && (
          <p className="text-[10px] text-gray-500 uppercase tracking-wider">AI Football Predictions</p>
        )}
      </div>
    </div>
  );
}
